import { render } from "./dentrion_slider.vue?vue&type=template&id=58d50706&scoped=true"
import script from "./dentrion_slider.vue?vue&type=script&lang=js"
export * from "./dentrion_slider.vue?vue&type=script&lang=js"

import "./dentrion_slider.vue?vue&type=style&index=0&id=58d50706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d50706"]])

export default __exports__